import React from 'react';
import MathCCA2025 from 'views/MathCCA2025';

const MathClubPage = () => {
  return <MathCCA2025/>;
};

export default MathClubPage;

